import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/settings/payment_time";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown/PaymentTime";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

 
    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
      }

}
